import axios from 'axios';

const api = axios.create({
  // baseURL: 'https://shielded-falls-76450.herokuapp.com/',
  // baseURL: 'https://deploy-node-in-vercel-iagoronanvs.vercel.app/',
  baseURL: 'https://deploy-node-in-vercel-jc0xponbe-iagoronanvs.vercel.app/',
});

export default api;
